'use strict';

module.exports = require('./es6/crc24').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crc24.js
// module id = 763
// module chunks = 0